import React from 'react';
import { clsx } from 'clsx';
import { Box, Heading, Accordion, Text, accordionItemBuilder, Divider } from '@wix/design-system';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import s from './faqs.scss';
import { Add, Minus } from '@wix/wix-ui-icons-common/lazy';
import { FaqsDataHooks } from './dataHooks';
import { useIsHarmonyTheme, useIsMobile } from '@wix/core-domain-search';
export const FAQs = _ref => {
  let {
    onToggle,
    variant = 'wix'
  } = _ref;
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  const isMobile = useIsMobile();
  const isHarmonyTheme = useIsHarmonyTheme();
  const keyPrefix = variant === 'base44' ? 'domain_search_gate.base44.faq' : 'domain_search_gate.domain_gate.faq';
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: FaqsDataHooks.component,
    direction: "vertical",
    gap: "SP4",
    width: "100%",
    align: "left",
    paddingTop: variant === 'base44' && isMobile ? '0' : 'SP10',
    display: "block",
    className: clsx(s.faqs, isHarmonyTheme && s.faqsHarmony)
  }, /*#__PURE__*/React.createElement(Box, {
    padding: "SP4 0 SP10 0"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "large",
    className: s.faqsTitle
  }, t(`${keyPrefix}.header`))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Accordion, {
    horizontalPadding: "none",
    hideShadow: true,
    multiple: true,
    transitionSpeed: "slow",
    size: "medium",
    items: Array.from({
      length: 12
    }).map((_, index) => accordionItemBuilder({
      onAnimationEnter: () => {
        onToggle == null || onToggle(index);
      },
      title: /*#__PURE__*/React.createElement(Text, {
        dataHook: FaqsDataHooks.question,
        className: s.faqQuestionTitle
      }, t(`${keyPrefix}.question_${index + 1}`)),
      buttonType: 'node',
      showLabel: 'always',
      expandLabel: /*#__PURE__*/React.createElement(Add, null),
      collapseLabel: /*#__PURE__*/React.createElement(Minus, null),
      children: /*#__PURE__*/React.createElement(Box, {
        dataHook: FaqsDataHooks.answer,
        padding: "SP6",
        backgroundColor: isHarmonyTheme ? 'var(--wds-color-fill-surface-default)' : '#F1F5F9',
        borderRadius: "12px"
      }, /*#__PURE__*/React.createElement(Box, {
        maxWidth: "630px"
      }, /*#__PURE__*/React.createElement(Text, {
        size: "small"
      }, t(`${keyPrefix}.answer_${index + 1}`))))
    }))
  }));
};
//# sourceMappingURL=FAQs.js.map